import React from 'react';
import { fullImagePath, generateClassName } from "../../b2b-common/helpers";
import ImageWithActions from "./ImageWithActions";

export function getImagePathByFrameworkId(frameworks, frameworkId) {
    if (!Array.isArray(frameworks)) {
        return null;
    }
    const framework = frameworks.find(fw => fw.frameworkId === frameworkId);
    return framework ? framework.imagePath : null;
}

export function getImagePathBulletByFrameworkIdAndFwLevelId(frameworks, frameworkId, fwLevelId) {
    const framework = frameworks.find(fw => fw.frameworkId === frameworkId);
    if (!framework) return null;
    const level = framework.subLevels.find(lvl => lvl.levelN_ItemId === fwLevelId);
    return level ? level.otherImages.find(image => image.endsWith('_bullet.jpg')) : null;
}

export function getImagesWithActions(image, handleEdit, handleDelete, className) {
    //console.log('getImagesWithActions:', element, handleEdit, handleDelete, className);
    return [
        <ImageWithActions
            key={image.imagePath}
            src={fullImagePath(image.imagePath)}
            alt={extractFilename(image.imagePath)}
            imageName={extractFilename(image.imagePath)}
            onEdit={handleEdit ? () => handleEdit(image.imagePath) : null}
            onDelete={handleDelete ? () => handleDelete(image.imagePath) : null}
            className={generateClassName("images-with-actions", "-main", className)}
        />,
        ...image.otherImages.map((image, index) => (
            <ImageWithActions
                key={index}
                src={fullImagePath(image)}
                alt={extractFilename(image)}
                imageName={extractFilename(image)}
                onEdit={handleEdit ? () => handleEdit(image) : null}
                onDelete={handleDelete ? () => handleDelete(image) : null}
                className={generateClassName("images-with-actions", "-other", className)}
            />
        ))
    ];
}

export const isValidFrameworkImagePath = (path) => {
    const regex = /^(\w+)\/frameworks\/(\w+)\/(\d+)\/fw_Image(_\w+)?(_\w+)?\.jpg$/;
    return regex.test(path);
};

export const extractFrameworkImageParams = (path) => {
    const filename = path.split('/').pop();
    const regex = /^fw_Image(_(\w+?))?(_([a-z]{2}))?\.jpg$/;
    const match = filename.match(regex);

    if (match) {
        return {
            imageLabel: match[2] || '',
            localeCode: match[4] || ''
        };
    } else {
        return null;
    }
};

export const isValidLevelNImagePath = (path) => {
    const regex = /^(\w+)\/frameworks\/(\w+)\/(\d+)\/(\d+)\/levelN_Image(_\w+)?(_\w+)?\.jpg$/;
    return regex.test(path);
};

export const extractLevelNImageParams = (path) => {
    const filename = path.split('/').pop();
    const regex = /^levelN_Image(_(\w+?))?(_([a-z]{2}))?\.jpg$/;
    const match = filename.match(regex);

    if (match) {
        return {
            imageLabel: match[2] || '',
            localeCode: match[4] || ''
        };
    } else {
        return null;
    }
};

export const extractFilename = (path) => {
    if (!path) return null;
    return path.split('/').pop();
}

export function getParentLevelNsIds(num) {
    let parents = [num];
    while (num >= 256) {
        num = Math.floor(num / 256);
        parents.push(num);
    }
    return parents.reverse();
}

export function getParentLevelNsOrders(num) {
    let parents = [num % 256];
    while (num >= 256) {
        num = Math.floor(num / 256);
        parents.push(num % 256);
    }
    return parents.reverse();
}

export function joinLevelNsIds(ids) {
    return ids.join('.');
}

export function getIdFromLevelNsOrders(levels) {
    let ids = [...levels].reverse();
    let id = 0;
    for (let i = 0; i < ids.length; i++) {
        id += ids[i] * Math.pow(256, i);
    }
    return id;
}

export function getMinIdFromLevelNsOrders(levels) {
    let minLevels = levels.filter(level => level !== null && level !== undefined && level !== "");
    if (minLevels.length > 0) {
        minLevels.push(1);
        return getIdFromLevelNsOrders(minLevels);
    }
    return null;
}

export function getMaxIdFromLevelNsOrders(levels) {
    let maxLevels = levels.filter(level => level !== null && level !== undefined && level !== "");
    if (maxLevels.length > 0) {
        maxLevels.push(256);
        return getIdFromLevelNsOrders(maxLevels);
    }
    return null;
}

export function getAllB2BIndicators(levelN) {
    let b2bIndicators = [...levelN.b2bIndicatorDTOs];
    if (levelN.subLevels && levelN.subLevels.length > 0) {
        for (let subLevel of levelN.subLevels) {
            b2bIndicators = [...b2bIndicators, ...getAllB2BIndicators(subLevel)];
        }
    }
    return b2bIndicators;
}

export const getFrameworkSuitte = (framework) => {
    if (framework.frameworkMicroserviceAcronym === 'IOTFW') {
        return 'iot';
    } else if (framework.frameworkMicroserviceAcronym === 'VERTICALFW') {
        return 'vertical';
    } else if (framework.frameworkMicroserviceAcronym === 'PARTNERSFW') {
        return 'partner';
    } else if (framework.frameworkMicroserviceAcronym === 'SOFTWAREFW') {
        return 'software';
    } else {
        return 'generic';
    }
};